import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  deleteObjectionApi,
  getObjectionsApi,
  getSingleObjectionApi,
} from "api/objections";
import {
  deleteObjectionFailure,
  deleteObjectionSuccess,
  getObjectionsFailure,
  getObjectionsSuccess,
  getSingleObjectionFailure,
  getSingleObjectionSuccess,
} from "./actions";
import {
  DELETE_OBJECTION,
  GET_OBJECTIONS,
  GET_SINGLE_OBJECTION,
} from "./actionTypes";
import { toast } from "react-toastify";

function* getObjectionsSaga() {
  try {
    const { data } = yield call(getObjectionsApi);
    yield put(getObjectionsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getObjectionsFailure(error?.response?.data?.errors?.[0]?.msg));
  }
}

function* getSingleObjectionSaga({ payload }) {
  try {
    const { data } = yield call(getSingleObjectionApi, payload);
    yield put(getSingleObjectionSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(
      getSingleObjectionFailure(error.response?.data?.message || error)
    );
  }
}

function* deleteObjectionSaga({ payload }) {
  try {
    yield call(deleteObjectionApi, payload);
    yield put(deleteObjectionSuccess(payload));
    yield toast.success("تم الحذف بنجاح");
  } catch (error) {
    console.log(error);
    yield put(deleteObjectionFailure(error?.response?.data || error));
    yield toast.error(
      JSON.stringify(error.response.data.errors?.map((err) => err.msg))
    );
  }
}

export function* watchGetObjections() {
  yield takeEvery(GET_OBJECTIONS, getObjectionsSaga);
}

export function* watchSingleObjection() {
  yield takeEvery(GET_SINGLE_OBJECTION, getSingleObjectionSaga);
}

export function* watchDeleteObjection() {
  yield takeEvery(DELETE_OBJECTION, deleteObjectionSaga);
}

function* objectionsSaga() {
  yield all([fork(watchGetObjections)]);
  yield all([fork(watchSingleObjection)]);
  yield all([fork(watchDeleteObjection)]);
}

export default objectionsSaga;
